import React, { createContext, useContext } from "react"

type LocaleProviderProps = {
  children: React.ReactNode
  locale: string
  defaultLocale: string
}

type LocaleContextData = {
  locale: string
  defaultLocale: string
}

const LocaleContext = createContext<LocaleContextData | undefined>(undefined)

export const useLocale = () => {
  const context = useContext(LocaleContext)

  if (!context) {
    throw new Error("useLocale must be used inside LocaleProvider")
  }

  return context
}

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children, locale, defaultLocale }) => (
  <LocaleContext.Provider value={{ locale, defaultLocale }}>{children}</LocaleContext.Provider>
)
